var cell_default = {
  "cell": "-zyMo",
  "header": "wnvJK",
  "selected": "MMwy7",
  "editing": "dF9Xa",
  "singleSelection": "udg-z",
  "hideLastBlock": "djPRT",
  "editorWrapper": "aOudq",
  "viewerWrapper": "_3ZJQV",
  "hideFirstBlock": "XICIV",
  "editor": "qWAq6",
  "edit": "_1n7Tz",
  "view": "w1-px",
  "editingToolbarWrapper": "NqNhU",
  "selectAll": "RszQv",
  "disableSelection": "PMYh8"
};
export {
  cell_default as default
};
//# sourceMappingURL=cell-scss.js.map
